export function spaceMaker( string ) {
    const text = string;
    const result = text.replace(/-/g, ' ');
    return result;
}